import React from 'react'
import styles from './styles.scss'

const RadioButton = props => (
  <input
    type="radio"
    className={styles['wrapper-radio-button']}
    {...props}
  />
)

export default RadioButton


// WEBPACK FOOTER //
// ./src/components/RadioButton/index.js